import { IEjariContext } from "@eres/ejari-core/contexts/EjariContext";
import { PathInfo } from "@my-dld/contexts/AppContext";
import { StringUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";
import { ErrorContainer } from "@eres/forms";

export function getNavigation( ctx: IEjariContext ): PathInfo[] {
	const x: PathInfo[] = [];
	if ( ctx && ctx.breadcrumbs ) {
		for ( const breadcrumb of ctx.breadcrumbs ) {
			x.push( {
				id: breadcrumb.id,
				label: breadcrumb.label,
				path: breadcrumb.link,
			} );
		}
	}
	return x;
}

export function hasValue( value: any ) {
	if ( value == null ) return false;
	if ( typeof value === "string" ) {
		return !StringUtil.isEmptyStringOrNull( value );
	}
	return true;
}

export function checkNonEmpty( value: any, key: string, errorContainer?: ErrorContainer, processor?: ( isNonEmpty: boolean ) => boolean ): boolean {
	let isNonEmpty = false;
	if ( value[ key ] != null ) {
		let v = value[ key ];
		if ( typeof ( v ) === "string" ) {
			isNonEmpty = !StringUtil.isEmptyStringOrNull( v );
		} else
			isNonEmpty = true;
	}
	if ( !isNonEmpty && errorContainer ) errorContainer[ key ] = Strings.required;
	isNonEmpty = processor?.( isNonEmpty ) ?? isNonEmpty;
	return isNonEmpty;
}

export function checkNonEmptyGtZeo( value: any, key: string, errorContainer?: ErrorContainer ): boolean {
	let isNonEmpty = checkNonEmpty( value, key, errorContainer );
	if ( isNonEmpty ) {
		const n = Number( value[ key ] );
		if ( n > 0 ) {

		} else {
			if ( errorContainer ) errorContainer[ key ] = Strings.required;
			return false;
		}
	}
	return isNonEmpty;
}
